module.exports = __webpack_public_path__ + "static/img/groundincease3.a775cd1c.png";